import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { withTranslation } from "react-i18next";
import crossIcon from "assets/images/cross.svg";
import AddNote from "accountOwner/pages/Notes/component/AddNote";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const AddNoteDashboardModal = ({
  t,
  isModalOpen,
  setIsModalOpen,
  editNoteModal,
}) => {
  const history = useHistory();
  return (
    <Modal
      isOpen={isModalOpen}
      toggle={setIsModalOpen}
      className="modal-lg modal-dialog-centered"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={setIsModalOpen}>
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <h1 className="title">{t("notes.addNote")}</h1>
        <AddNote
          formOnly={true}
          t={t}
          history={history}
          editNoteModal={editNoteModal}
          closeDashboardModal={setIsModalOpen}
        />
      </ModalBody>
    </Modal>
  );
};

export default withTranslation()(AddNoteDashboardModal);
